import { useSearchParams } from 'react-router-dom'

/** True when the sim is iframed (slides embed) or opened with ?embed=true. */
export default function useEmbedded() {
  const [searchParams] = useSearchParams()
  const embedParam = searchParams.get('embed') === 'true' || searchParams.get('embed') === '1'
  const inIframe = typeof window !== 'undefined' && window.self !== window.top
  return embedParam || inIframe
}
